import moment from "moment";
import { maxBy, sumBy, toFinite } from "lodash";

type WeekLine = {
  startDate?: Date | string | null;
  stayedNights: number;
};

export interface WeekStayedPeriod {
  endDate: Date;
  nights: number;
}

/**
 * A week's check-out and nights as the consultant stayed them. ERP sends each
 * reservation's whole booked period on its line, so the week card would show
 * the booking's check-out instead of the week's; the lines' nights stayed are
 * what the week taxes. Null for a week without lines or dates, which keeps its own.
 */
export function getWeekStayedPeriod(week: {
  startDate?: Date | string | null;
  lines?: WeekLine[] | null;
}): WeekStayedPeriod | null {
  const lines = week.lines ?? [];
  if (lines.some((x) => !(x.startDate ?? week.startDate))) {
    return null;
  }
  const checkOuts = lines.map((x) =>
    moment.utc(x.startDate ?? week.startDate).add(toFinite(x.stayedNights), "days")
  );
  if (!checkOuts.length) {
    return null;
  }
  return {
    endDate: maxBy(checkOuts, (x) => x.valueOf()).toDate(),
    nights: sumBy(lines, (x) => toFinite(x.stayedNights))
  };
}
